<!-- <div class="language-selector-container">
  <p-select
    [options]="languages"
    [ngModel]="$selectedLanguage()"
    (onChange)="onLanguageChange($event)"
    optionLabel="name"
    styleClass="p-dropdown-sm"
    ariaLabel="Seletor de Idioma"
  >
  </p-select>
</div> -->

<ul class="language-list">
  @for (lang of languages; track lang.code) {
  <li
    [class.selected]="lang.code === $currentLanguage().code"
    (click)="onLanguageChange(lang)"
    (keydown.enter)="onLanguageChange(lang)"
    tabindex="0"
  >
    <img [src]="lang.flag" [alt]="lang.name" class="flag-icon" />
    <span>{{ lang.name }}</span>
  </li>
  }
</ul>
